/** Pure log-log chart geometry for the TCC viewer. No React, no DOM. */

export interface Scale {
  domainMinLog: number
  domainMaxLog: number
  pxMin: number
  pxMax: number
}

/** Map a positive value to a pixel via log10, clamped to the pixel range. */
export function logScale(value: number, s: Scale): number {
  if (value <= 0) return s.pxMin
  const lv = Math.log10(value)
  const f = (lv - s.domainMinLog) / (s.domainMaxLog - s.domainMinLog)
  const px = s.pxMin + f * (s.pxMax - s.pxMin)
  return Math.max(Math.min(px, Math.max(s.pxMin, s.pxMax)), Math.min(s.pxMin, s.pxMax))
}

/** Build an SVG polyline "x,y x,y ..." for [[current, time], ...] points. */
export function curveToPoints(
  points: number[][],
  xScale: Scale,
  yScale: Scale,
): string {
  return points
    .map(([a, t]) => `${logScale(a, xScale).toFixed(1)},${logScale(t, yScale).toFixed(1)}`)
    .join(' ')
}
